// EV Cable Hub — global theme behaviour
(function () {
  'use strict';

  // ─── Money formatter (covers basic Shopify formats: amount, amount_no_decimals, with_comma_separator)
  window.theme.formatMoney = function (cents, format) {
    var fmt = format || window.theme.moneyFormat || '£{{amount}}';
    var value = (cents / 100);
    var parts;
    if (fmt.indexOf('amount_no_decimals') !== -1) {
      parts = Math.round(value).toString();
      parts = parts.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*amount_no_decimals(_with_comma_separator)?\s*\}\}/g, parts);
    }
    parts = value.toFixed(2);
    var split = parts.split('.');
    split[0] = split[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/g, split.join('.'));
  };

  // ─── Header transparent-on-home behaviour
  function initHeaderTransparent() {
    var header = document.querySelector('.site-header[data-transparent]');
    if (!header || !document.body.classList.contains('template-index')) return;
    var update = function () { header.classList.toggle('is-scrolled', window.scrollY > 60); };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  // ─── Reveal-on-scroll
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  // ─── Home car picker (legacy "tabs" version — kept for any /pages using the older block layout)
  function initCarPicker() {
    var picker = document.querySelector('[data-car-picker]');
    if (!picker) return;
    var tabs = picker.querySelectorAll('[data-car-tab]');
    var panes = picker.querySelectorAll('[data-car-pane]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var make = tab.getAttribute('data-car-tab');
        tabs.forEach(function (t) { t.classList.toggle('active', t === tab); });
        panes.forEach(function (p) {
          p.hidden = p.getAttribute('data-car-pane') !== make;
        });
        var meta = picker.querySelector('[data-car-meta-make]');
        if (meta) meta.textContent = make;
      });
    });
  }

  // ─── Hero inline picker — Make · Model · Year + Find Chargers
  function initHeroPicker() {
    var root = document.querySelector('[data-hero-picker]');
    if (!root) return;
    var dataUrl = root.getAttribute('data-models-url');
    if (!dataUrl) return;

    var makeSel  = root.querySelector('[data-hero-make]');
    var modelSel = root.querySelector('[data-hero-model]');
    var yearSel  = root.querySelector('[data-hero-year]');
    var cta      = root.querySelector('[data-hero-submit]');
    var ctaLabel = root.querySelector('[data-hero-cta-label]');
    var resultEl = root.querySelector('[data-hero-result]');

    var dataset = null;
    var loadPromise = null;

    function loadData() {
      if (dataset) return Promise.resolve(dataset);
      if (loadPromise) return loadPromise;
      loadPromise = fetch(dataUrl, { credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (d) { dataset = d; return d; })
        .catch(function (err) { console.error('hero-picker: model data failed', err); return null; });
      return loadPromise;
    }

    function brandById(id) {
      if (!dataset) return null;
      for (var i = 0; i < dataset.brands.length; i++) {
        if (dataset.brands[i].id === id) return dataset.brands[i];
      }
      return null;
    }

    function clearOptions(sel, placeholderText) {
      sel.innerHTML = '';
      var ph = document.createElement('option');
      ph.value = ''; ph.textContent = placeholderText || 'Select'; ph.selected = true;
      sel.appendChild(ph);
    }

    function yearsFromRange(yearStr) {
      // e.g. "2017–", "2014–2018", "2010–2014"
      if (!yearStr) return [];
      var current = new Date().getFullYear();
      var clean = String(yearStr).replace(/–|—/g, '-').replace(/\s/g, '');
      var parts = clean.split('-');
      var start = parseInt(parts[0], 10);
      var end = parts[1] ? parseInt(parts[1], 10) : current;
      if (isNaN(start)) return [];
      if (isNaN(end)) end = current;
      var out = [];
      for (var y = end; y >= start; y--) out.push(String(y));
      return out;
    }

    function updateCTA() {
      var ready = !!(makeSel.value && modelSel.value !== '' && yearSel.value);
      cta.disabled = !ready;
      if (ready) {
        var brand = brandById(makeSel.value);
        var modelIdx = parseInt(modelSel.value, 10);
        var model = brand ? brand.models[modelIdx] : null;
        if (model) {
          var label = (model.connector === 'type-1') ? 'Find Type 1 cables' : 'Find ' + brand.label + ' cables';
          ctaLabel.textContent = label;
        }
      } else {
        ctaLabel.textContent = 'Find chargers';
      }
    }

    function showSummary(brand, model) {
      if (!resultEl) return;
      var connector = (model.connector === 'type-1') ? 'Type 1 (J1772)' : 'Type 2 (Mennekes)';
      var v2l = model.v2l ? ' · V2L supported' : '';
      var maxKw = model.max_ac_kw ? (' · ' + model.max_ac_kw + ' kW max AC') : '';
      var url = (model.connector === 'type-1') ? '/collections/type-1-charging-cables' : '/collections/' + brand.collection;
      resultEl.innerHTML = 'Your ' + brand.label + ' ' + model.name +
        ' uses <strong>' + connector + '</strong>' + maxKw + v2l +
        '. <a href="' + url + '">Browse the right cables →</a>';
      resultEl.removeAttribute('hidden');
    }

    // Make change → populate Model
    makeSel.addEventListener('change', function () {
      clearOptions(modelSel);
      clearOptions(yearSel);
      modelSel.disabled = true;
      yearSel.disabled = true;
      if (resultEl) resultEl.setAttribute('hidden', '');
      if (!makeSel.value) { updateCTA(); return; }
      loadData().then(function () {
        var brand = brandById(makeSel.value);
        if (!brand) return;
        brand.models.forEach(function (m, i) {
          var opt = document.createElement('option');
          opt.value = String(i);
          opt.textContent = m.name;
          modelSel.appendChild(opt);
        });
        modelSel.disabled = false;
        updateCTA();
      });
    });

    // Model change → populate Year
    modelSel.addEventListener('change', function () {
      clearOptions(yearSel);
      yearSel.disabled = true;
      if (resultEl) resultEl.setAttribute('hidden', '');
      if (modelSel.value === '' || !makeSel.value) { updateCTA(); return; }
      var brand = brandById(makeSel.value);
      var modelIdx = parseInt(modelSel.value, 10);
      var model = brand ? brand.models[modelIdx] : null;
      if (!model) { updateCTA(); return; }
      var years = yearsFromRange(model.years);
      if (years.length === 0) {
        var opt = document.createElement('option');
        opt.value = 'all'; opt.textContent = 'All years';
        yearSel.appendChild(opt);
      } else {
        years.forEach(function (y) {
          var opt = document.createElement('option');
          opt.value = y; opt.textContent = y;
          yearSel.appendChild(opt);
        });
      }
      yearSel.disabled = false;
      updateCTA();
    });

    // Year change → enable CTA + show inline summary
    yearSel.addEventListener('change', function () {
      if (!yearSel.value) { updateCTA(); return; }
      var brand = brandById(makeSel.value);
      var modelIdx = parseInt(modelSel.value, 10);
      var model = brand ? brand.models[modelIdx] : null;
      if (model) showSummary(brand, model);
      updateCTA();
    });

    // Submit → save selection + navigate
    cta.addEventListener('click', function () {
      if (cta.disabled) return;
      var brand = brandById(makeSel.value);
      var modelIdx = parseInt(modelSel.value, 10);
      var model = brand ? brand.models[modelIdx] : null;
      if (!brand || !model) return;
      try {
        localStorage.setItem('evhub:car', JSON.stringify({
          brand_id: brand.id, brand_label: brand.label,
          model_name: model.name, model_index: modelIdx,
          year: yearSel.value, connector: model.connector, max_ac_kw: model.max_ac_kw, v2l: !!model.v2l
        }));
      } catch (e) {}
      var dest = (model.connector === 'type-1')
        ? '/collections/type-1-charging-cables'
        : '/collections/' + brand.collection;
      window.location.href = dest;
    });

    updateCTA();
  }

  // ─── (Legacy) Home picker — brand → model → recommendation (kept for any old standalone section)
  function initHomePicker() {
    var root = document.querySelector('[data-picker]');
    if (!root) return;
    var dataUrl = root.getAttribute('data-models-url');
    if (!dataUrl) return;

    var stage = root.querySelector('[data-picker-stage]');
    var steps = {
      brand:  stage.querySelector('[data-picker-step="brand"]'),
      model:  stage.querySelector('[data-picker-step="model"]'),
      result: stage.querySelector('[data-picker-step="result"]')
    };
    var modelSelect = root.querySelector('[data-picker-model]');
    var brandLabel  = root.querySelector('[data-picker-brand-label]');
    var resultEls = {
      car:      root.querySelector('[data-picker-result-car]'),
      detail:   root.querySelector('[data-picker-result-detail]'),
      headline: root.querySelector('[data-picker-result-headline]'),
      copy:     root.querySelector('[data-picker-result-copy]'),
      spec:     root.querySelector('[data-picker-result-spec]'),
      cta:      root.querySelector('[data-picker-result-cta]'),
      ctaLabel: root.querySelector('[data-picker-result-cta-label]')
    };

    var dataset = null;
    var currentBrand = null;

    function showStep(name) {
      Object.keys(steps).forEach(function (k) {
        var el = steps[k];
        if (k === name) { el.removeAttribute('hidden'); el.classList.add('home-picker-step--active'); }
        else { el.setAttribute('hidden',''); el.classList.remove('home-picker-step--active'); }
      });
      // Move keyboard focus to the active step's heading for accessibility
      var label = steps[name].querySelector('.home-picker-step-label');
      if (label) label.scrollIntoView({behavior:'smooth', block:'nearest'});
    }

    function loadData() {
      if (dataset) return Promise.resolve(dataset);
      return fetch(dataUrl, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (d) {
        dataset = d; return d;
      });
    }

    function brandById(id) {
      if (!dataset) return null;
      for (var i = 0; i < dataset.brands.length; i++) {
        if (dataset.brands[i].id === id) return dataset.brands[i];
      }
      return null;
    }

    function buildModelOptions(brand) {
      modelSelect.innerHTML = '';
      var placeholder = document.createElement('option');
      placeholder.value = ''; placeholder.textContent = 'Pick a model…'; placeholder.disabled = true; placeholder.selected = true;
      modelSelect.appendChild(placeholder);
      brand.models.forEach(function (m, idx) {
        var opt = document.createElement('option');
        opt.value = String(idx);
        opt.textContent = m.name + (m.years ? '  ·  ' + m.years : '');
        modelSelect.appendChild(opt);
      });
    }

    function recommend(brand, model) {
      var connector = model.connector || 'type-2';
      var maxKw = model.max_ac_kw || 7.4;
      var dcPort = (model.dc_port || '').toUpperCase();
      var v2l = !!model.v2l;

      var connectorLabel = connector === 'type-2' ? 'Type 2 (Mode 3)' : 'Type 1 (J1772)';
      // Length recommendation defaults — 10m for most, 7.4kW for single-phase, 22kW only if model supports
      var recLength = '10m';
      var recPower  = maxKw >= 22 ? '22kW (three-phase)' : maxKw >= 11 ? '11kW (three-phase)' : maxKw >= 7 ? '7.4kW (32A single-phase)' : '3.6kW (16A single-phase)';
      var collectionUrl = (connector === 'type-1')
        ? '/collections/type-1-charging-cables'
        : '/collections/' + brand.collection;

      // Fallback if brand has no dedicated collection: route to type-2 master
      if (!brand.collection) collectionUrl = '/collections/type-2-charging-cables';

      // Headline + copy
      var headline = 'Your <em>' + model.name + '</em> needs a ' + connectorLabel + ' cable.';
      var copy;
      if (connector === 'type-1') {
        copy = 'Your ' + brand.label + ' ' + model.name + ' uses the older Type 1 (J1772) AC standard. We stock matching Type 1 cables and Type 1-to-Type 2 adapters for use at modern Type 2 wallboxes.';
      } else {
        copy = 'Your ' + brand.label + ' ' + model.name + ' uses the standard UK Type 2 (Mennekes) plug. We recommend a ' + recLength + ' cable rated to ' + recPower + ' so you have slack for either-side parking and headroom on faster wallboxes.';
        if (v2l) copy += ' Your car also supports V2L — see our V2L adapters for ' + brand.label + ' if you want to power external devices from the battery.';
      }

      var ctaLabel;
      if (connector === 'type-1') ctaLabel = 'Shop Type 1 cables →';
      else if (brand.collection) ctaLabel = 'Shop ' + brand.label + ' cables →';
      else ctaLabel = 'Shop Type 2 cables →';

      // Render
      resultEls.car.textContent = brand.label + ' ' + model.name;
      resultEls.detail.textContent = (model.years || '') + (model.note ? '  ·  ' + model.note : '');
      resultEls.headline.innerHTML = headline;
      resultEls.copy.textContent = copy;

      var specs = [
        { label: 'AC port',         value: connectorLabel },
        { label: 'Max AC',          value: maxKw + 'kW' },
        { label: 'Recommended cable', value: recLength + ' · ' + recPower.split(' ')[0] }
      ];
      if (dcPort && dcPort !== 'NULL') specs.push({ label: 'DC fast', value: dcPort });
      if (v2l) specs.push({ label: 'V2L', value: 'Supported' });

      resultEls.spec.innerHTML = '';
      specs.forEach(function (s) {
        var li = document.createElement('li');
        var strong = document.createElement('strong'); strong.textContent = s.label;
        var span   = document.createElement('span');   span.textContent   = s.value;
        li.appendChild(strong); li.appendChild(span);
        resultEls.spec.appendChild(li);
      });

      resultEls.cta.setAttribute('href', collectionUrl);
      resultEls.ctaLabel.textContent = ctaLabel;
    }

    // Brand click handlers
    root.querySelectorAll('[data-picker-brand]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-picker-brand');
        loadData().then(function () {
          var brand = brandById(id);
          if (!brand) return;
          currentBrand = brand;
          if (brandLabel) brandLabel.textContent = brand.label + ' model';
          buildModelOptions(brand);
          showStep('model');
        }).catch(function (err) {
          console.error('home-picker: failed to load models', err);
        });
      });
    });

    // Model select handler
    if (modelSelect) {
      modelSelect.addEventListener('change', function () {
        if (!currentBrand) return;
        var idx = parseInt(modelSelect.value, 10);
        if (isNaN(idx)) return;
        var model = currentBrand.models[idx];
        if (!model) return;
        recommend(currentBrand, model);
        showStep('result');
      });
    }

    // Back / restart handlers
    root.querySelectorAll('[data-picker-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-picker-back');
        currentBrand = null;
        if (modelSelect) modelSelect.innerHTML = '';
        showStep(target || 'brand');
      });
    });
  }

  // ─── PDP gallery thumbnails
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var hero = gallery.querySelector('[data-gallery-hero] img');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        if (hero && src) hero.src = src;
        if (hero && srcset) hero.srcset = srcset;
        thumbs.forEach(function (t) { t.classList.toggle('active', t === thumb); });
      });
    });
  }

  // ─── PDP tabs
  function initTabs() {
    var nav = document.querySelector('[data-pdp-tabs]');
    if (!nav) return;
    var tabs = nav.querySelectorAll('[data-pdp-tab]');
    var panels = document.querySelectorAll('[data-pdp-panel]');
    var go = function (id) {
      tabs.forEach(function (t) { t.classList.toggle('active', t.getAttribute('data-pdp-tab') === id); });
      panels.forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-pdp-panel') === id); });
      try { history.replaceState(null, '', '#tab-' + id); } catch (e) {}
    };
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { go(t.getAttribute('data-pdp-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var arr = Array.prototype.slice.call(tabs);
        var i = arr.indexOf(document.activeElement);
        var next = e.key === 'ArrowRight' ? (i + 1) % arr.length : (i - 1 + arr.length) % arr.length;
        arr[next].focus();
        go(arr[next].getAttribute('data-pdp-tab'));
      });
    });
    if (location.hash && location.hash.indexOf('#tab-') === 0) {
      go(location.hash.replace('#tab-', ''));
    }
  }

  // ─── PDP FAQ accordion
  function initFaqs() {
    document.querySelectorAll('.faq-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.faq-item');
        if (!item) return;
        item.classList.toggle('open');
        var open = item.classList.contains('open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  // ─── Sticky add-to-bag bar
  function initStickyAddBar() {
    var bar = document.querySelector('[data-sticky-add-bar]');
    if (!bar) return;
    var toggle = function () { bar.classList.toggle('in', window.scrollY > 600); };
    toggle();
    window.addEventListener('scroll', toggle, { passive: true });
  }

  // ─── Delivery countdown for in-stock pill
  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var update = function () {
        var now = new Date();
        var cutoff = new Date(now);
        cutoff.setHours(16, 0, 0, 0);
        var day = now.getDay();
        var weekend = (day === 0 || day === 6);
        if (weekend || now > cutoff) {
          el.textContent = 'Order before 16:00 Monday for next-day delivery.';
          return;
        }
        var diff = cutoff - now;
        var hr = Math.floor(diff / 3600000);
        var min = Math.floor((diff % 3600000) / 60000);
        el.innerHTML = 'Order in the next <strong>' + hr + ' hr ' + min + ' min</strong> for next-day UK delivery.';
      };
      update();
      setInterval(update, 60000);
    });
  }

  // ─── Charger Finder
  function initFinder() {
    var form = document.querySelector('[data-finder]');
    if (!form) return;
    var carsRaw = form.getAttribute('data-cars') || '[]';
    var rulesRaw = form.getAttribute('data-rules') || '[]';
    var cars = [];
    var rules = [];
    try { cars = JSON.parse(carsRaw); } catch (e) {}
    try { rules = JSON.parse(rulesRaw); } catch (e) {}

    var state = { make: '', model: '', context: '' };
    var stepModel = form.querySelector('[data-finder-step="model"]');
    var stepContext = form.querySelector('[data-finder-step="context"]');
    var modelOptions = form.querySelector('[data-finder-model-options]');

    form.querySelectorAll('[data-finder-make]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.make = btn.getAttribute('data-finder-make');
        state.model = '';
        form.querySelectorAll('[data-finder-make]').forEach(function (b) {
          b.classList.toggle('active', b === btn);
        });
        var car = cars.find(function (c) { return c.make === state.make; });
        if (car && modelOptions) {
          modelOptions.innerHTML = car.models.map(function (m) {
            return '<button type="button" class="finder-option" data-finder-model="' + escapeHtml(m) + '">' + escapeHtml(m) + '</button>';
          }).join('');
          stepModel.hidden = false;
          stepContext.hidden = true;
          bindModel();
          updateResult();
        }
      });
    });

    function bindModel() {
      modelOptions.querySelectorAll('[data-finder-model]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.model = btn.getAttribute('data-finder-model');
          modelOptions.querySelectorAll('button').forEach(function (b) {
            b.classList.toggle('active', b === btn);
          });
          stepContext.hidden = false;
          updateResult();
        });
      });
    }

    form.querySelectorAll('[data-finder-context]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.context = btn.getAttribute('data-finder-context');
        form.querySelectorAll('[data-finder-context]').forEach(function (b) {
          b.classList.toggle('active', b === btn);
        });
        updateResult();
      });
    });

    function updateResult() {
      var resultBox = document.querySelector('[data-finder-result]');
      var summaryBox = document.querySelector('[data-finder-result-summary]');
      if (!resultBox) return;
      if (!state.make || !state.model || !state.context) {
        resultBox.hidden = true;
        return;
      }
      var match = null;
      for (var i = 0; i < rules.length; i++) {
        var rule = rules[i];
        var cond = rule.if || {};
        var ok = true;
        if (cond.make && cond.make.indexOf(state.make) === -1) ok = false;
        if (ok && cond.context && cond.context !== state.context) ok = false;
        if (ok) { match = rule.then; break; }
      }
      if (!match) match = 'ohme-pro';
      var tile = document.querySelector('[data-finder-product="' + match + '"]');
      var tiles = document.querySelectorAll('[data-finder-product]');
      tiles.forEach(function (t) { t.hidden = (t !== tile); });
      if (summaryBox) summaryBox.textContent = 'Our recommendation for your ' + state.make + ' ' + state.model;
      resultBox.hidden = false;
    }

    var resetBtn = form.querySelector('[data-finder-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        state = { make: '', model: '', context: '' };
        form.querySelectorAll('button.active').forEach(function (b) { b.classList.remove('active'); });
        if (stepModel) stepModel.hidden = true;
        if (stepContext) stepContext.hidden = true;
        var resultBox = document.querySelector('[data-finder-result]');
        if (resultBox) resultBox.hidden = true;
      });
    }
  }

  // ─── Charger Finder v2 — make → model → context, JSON-data-driven
  function initFinderV2() {
    var form = document.querySelector('[data-finder-v2]');
    if (!form) return;
    var dataUrl = form.getAttribute('data-models-url');
    if (!dataUrl) return;

    var steps = {
      make:    form.querySelector('[data-finder-step="make"]'),
      model:   form.querySelector('[data-finder-step="model"]'),
      context: form.querySelector('[data-finder-step="context"]'),
      result:  form.querySelector('[data-finder-step="result"]')
    };
    var modelOpts = form.querySelector('[data-finder-model-options]');
    var resultEls = {
      eyebrow:        form.querySelector('[data-finder-result-eyebrow]'),
      headline:       form.querySelector('[data-finder-result-headline]'),
      copy:           form.querySelector('[data-finder-result-copy]'),
      spec:           form.querySelector('[data-finder-result-spec]'),
      cta:            form.querySelector('[data-finder-cta-primary]'),
      ctaLabel:       form.querySelector('[data-finder-cta-primary-label]'),
      ctaSecondary:   form.querySelector('[data-finder-cta-secondary]'),
      ctaSecondaryLabel: form.querySelector('[data-finder-cta-secondary-label]')
    };

    var dataset = null;
    var loadPromise = null;
    var state = { brand: null, model: null, context: null };

    function loadData() {
      if (dataset) return Promise.resolve(dataset);
      if (loadPromise) return loadPromise;
      loadPromise = fetch(dataUrl, { credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (d) { dataset = d; return d; });
      return loadPromise;
    }
    function brandById(id) {
      if (!dataset) return null;
      for (var i = 0; i < dataset.brands.length; i++) {
        if (dataset.brands[i].id === id) return dataset.brands[i];
      }
      return null;
    }

    function showStep(name) {
      Object.keys(steps).forEach(function (k) {
        var el = steps[k]; if (!el) return;
        if (k === name) { el.removeAttribute('hidden'); el.classList.add('finder-step--active'); }
        else { el.setAttribute('hidden',''); el.classList.remove('finder-step--active'); }
      });
    }

    // Make click handlers
    form.querySelectorAll('[data-finder-make]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-finder-make');
        loadData().then(function () {
          var brand = brandById(id);
          if (!brand) return;
          state.brand = brand;
          state.model = null; state.context = null;
          // Build model buttons
          modelOpts.innerHTML = '';
          brand.models.forEach(function (m, i) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'finder-option';
            b.setAttribute('data-finder-model', String(i));
            b.innerHTML = '<span class="finder-option-title">' + escapeHtml(m.name) + '</span>' +
                          '<span class="finder-option-sub">' + escapeHtml(m.years || '') + '</span>';
            b.addEventListener('click', function () {
              state.model = m;
              modelOpts.querySelectorAll('button').forEach(function (x) { x.classList.toggle('active', x === b); });
              showStep('context');
            });
            modelOpts.appendChild(b);
          });
          showStep('model');
        });
      });
    });

    // Context click handlers
    form.querySelectorAll('[data-finder-context]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.context = btn.getAttribute('data-finder-context');
        form.querySelectorAll('[data-finder-context]').forEach(function (x) { x.classList.toggle('active', x === btn); });
        renderResult();
      });
    });

    // Back buttons
    form.querySelectorAll('[data-finder-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = btn.getAttribute('data-finder-back');
        if (t === 'make') { state = { brand: null, model: null, context: null }; }
        else if (t === 'model') { state.model = null; state.context = null; }
        showStep(t || 'make');
      });
    });

    function renderResult() {
      if (!state.brand || !state.model || !state.context) return;
      var brand = state.brand, model = state.model, context = state.context;
      var connector = model.connector === 'type-1' ? 'Type 1 (J1772)' : 'Type 2 (Mennekes)';
      var maxKw = model.max_ac_kw || 7.4;
      var v2l = !!model.v2l;

      // Recommendation routing
      var primary = { url: '/collections/' + brand.collection, label: 'Shop ' + brand.label + ' cables →' };
      var secondary = null;

      if (model.connector === 'type-1') {
        // Type 1 cars override everything — the only AC option for them
        primary = { url: '/collections/type-1-to-type-2-charging-cables', label: 'Shop Type 1 to Type 2 cables →' };
        secondary = { url: '/collections/type-1-charging-cables', label: 'See all Type 1 cables →' };
      } else if (context === 'home-wallbox') {
        primary = { url: '/collections/' + brand.collection, label: 'Shop ' + brand.label + ' cables →' };
        if (maxKw >= 11) secondary = { url: '/collections/11kw-charging-cables', label: 'See 11kW three-phase cables →' };
        else secondary = { url: '/collections/7-4kw-charging-cables', label: 'See 7.4kW cables →' };
      } else if (context === 'public') {
        primary = { url: '/collections/' + brand.collection, label: 'Shop ' + brand.label + ' cables →' };
        secondary = { url: '/collections/type-2-charging-cables', label: 'All Type 2 cables →' };
      } else if (context === 'commando') {
        primary = { url: '/collections/type-2-to-commando-cables', label: 'Shop Type 2 to Commando cables →' };
        secondary = { url: '/collections/' + brand.collection, label: 'Or a standard ' + brand.label + ' cable →' };
      } else if (context === 'three-pin') {
        primary = { url: '/collections/granny-chargers', label: 'Shop granny cables →' };
        secondary = { url: '/collections/' + brand.collection, label: 'See ' + brand.label + ' cables →' };
      } else if (context === 'europe') {
        primary = { url: '/collections/type-2-to-schuko-cables', label: 'Shop Schuko cables →' };
        secondary = { url: '/collections/granny-chargers', label: 'Or a UK 3-pin granny cable →' };
      } else if (context === 'long-reach') {
        primary = { url: '/collections/15m-ev-charging-cables', label: 'Shop 15m cables →' };
        secondary = { url: '/collections/' + brand.collection, label: 'See ' + brand.label + ' lengths →' };
      }
      // V2L upsell when applicable
      if (v2l && !secondary) secondary = { url: '/collections/v2l-adapters', label: 'See V2L adapters →' };

      // Build summary
      var headline = 'Your ' + brand.label + ' ' + model.name;
      var copyBits = ['Uses <strong>' + connector + '</strong>'];
      copyBits.push('max <strong>' + maxKw + ' kW AC</strong>');
      if (v2l) copyBits.push('<strong>V2L</strong> supported');
      var copy = copyBits.join(' · ') + '.';

      if (resultEls.eyebrow) resultEls.eyebrow.textContent = 'Our recommendation';
      if (resultEls.headline) resultEls.headline.textContent = headline;
      if (resultEls.copy) resultEls.copy.innerHTML = copy;

      if (resultEls.spec) {
        resultEls.spec.innerHTML = '';
        var specs = [
          { l: 'AC port', v: connector },
          { l: 'Max AC',  v: maxKw + ' kW' }
        ];
        if (model.dc_port) specs.push({ l: 'DC fast', v: String(model.dc_port).toUpperCase() });
        if (v2l) specs.push({ l: 'V2L', v: 'Supported' });
        specs.forEach(function (s) {
          var li = document.createElement('li');
          var strong = document.createElement('strong'); strong.textContent = s.l;
          var span = document.createElement('span'); span.textContent = s.v;
          li.appendChild(strong); li.appendChild(span);
          resultEls.spec.appendChild(li);
        });
      }

      if (resultEls.cta) {
        resultEls.cta.setAttribute('href', primary.url);
        if (resultEls.ctaLabel) resultEls.ctaLabel.textContent = primary.label;
      }
      if (resultEls.ctaSecondary) {
        if (secondary) {
          resultEls.ctaSecondary.setAttribute('href', secondary.url);
          if (resultEls.ctaSecondaryLabel) resultEls.ctaSecondaryLabel.textContent = secondary.label;
          resultEls.ctaSecondary.removeAttribute('hidden');
        } else {
          resultEls.ctaSecondary.setAttribute('hidden','');
        }
      }
      showStep('result');
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Run on DOM ready
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  // ─── Mobile menu (hamburger + accordion)
  function initMobileMenu() {
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var menu = document.getElementById('MobileMenu');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () {
      var open = menu.hasAttribute('hidden');
      if (open) {
        menu.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Close menu');
        document.body.style.overflow = 'hidden';
      } else {
        menu.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        document.body.style.overflow = '';
        menu.querySelectorAll('[data-mobile-accordion]').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var panel = b.nextElementSibling;
          if (panel) panel.setAttribute('hidden', '');
        });
      }
    });
    menu.querySelectorAll('[data-mobile-accordion]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var panel = btn.nextElementSibling;
        if (!panel) return;
        if (expanded) panel.setAttribute('hidden', '');
        else panel.removeAttribute('hidden');
      });
    });
    var mq = window.matchMedia('(min-width: 1024px)');
    var onResize = function (e) {
      if (e.matches && !menu.hasAttribute('hidden')) toggle.click();
    };
    if (mq.addEventListener) mq.addEventListener('change', onResize);
    else if (mq.addListener) mq.addListener(onResize);
  }

  ready(function () {
    initHeaderTransparent();
    initReveal();
    initCarPicker();
    initHomePicker();
    initHeroPicker();
    initGallery();
    initTabs();
    initFaqs();
    initStickyAddBar();
    initCountdown();
    initFinder();
    initFinderV2();
    initMobileMenu();
  });
})();
